import LicensesList from './_components/LicensesList';

const ManagementPage = () => {
  return (
    <>
      <LicensesList />
    </>
  );
};

export default ManagementPage;
